export class FacilityBase {
  protected isAttendeeCountRequired = false;
  protected isWaitlistEnabled = false;
  protected isMaxBookingsPerSlot = false;
  protected isChargable = false;
  protected isHoldBooking = false;
  protected isMaxBookingPerMembership = false;
  protected isMaxBookingPerPerson = false;
  protected isPeakTimeEnabled = true;
  protected isBreakTimeEnabled = true;
  protected isAllowForceBooking = false;
  protected isReadOnly = false;
  protected editStatus = false;
  protected viewStatus = false;
  protected addFacilityStatus = false;
  protected closeTimeArray;
  protected openTime_hour;
  protected openTime_minute;
  protected closeTime_hour;
  protected closeTime_minute;
  protected peekTimingsArray = [];
  protected closedTime = {};
  protected closedStartTime_hour;
  protected closedStartTime_minute;
  protected closedStartTime;
  protected closedEndTime;
  protected closedEndTime_hour;
  protected closedEndTime_minute;
  protected peekStartTime;
  protected peekStartTime_hour;
  protected peekStartTime_minute;
  protected peekEndTime;
  protected peekEndTime_hour;
  protected peekEndTime_minute;
  protected peakTime = {};
  protected clubName = '';
  protected pageName;
  protected unitNames;
  protected isGSTApplicable = false;
  protected isCourtSelection = false;
  protected isOpenBookingOnFriday = false;
  protected isOpenNextMonthBooking = false;
  protected isSlotsLocked = true;
  public isCreatedForGroup = false;
  public isWeeklyRepeatBooking = false;
  public showEventActivity = true;
  constructor() {
  }

  /**
       * Toggle buttons for active or not
       *
       * @param  flag as true or false
       *
       * @Toggle button
       */
  toggle(that, Case, flag) {
    switch (Case) {
      case 1:
        that.isAttendeeCountRequired = flag;
        break;
      case 2:
        that.isWaitlistEnabled = flag;
        break;
      case 3:
        that.isChargable = flag;
        break;
      case 4:
        that.isHoldBooking = flag;
        break;
      case 5:
        that.isMaxBookingPerMembership = flag;
        break;
      case 6:
        that.isMaxBookingPerPerson = flag;
        break;
      case 7:
        that.isPeakTimeEnabled = flag;
        break;
      case 8:
        that.isBreakTimeEnabled = flag;
        break;
      case 9:
        that.isMaxBookingsPerSlot = flag;
        break;
      case 10:
        that.isAllowForceBooking = flag;
        break;
      case 11:
        that.isCourtSelection = flag;
        break;
      case 12:
        that.isOpenBookingOnFriday = flag;
        break;
      case 13:
        that.isSlotsLocked = flag;
        break;
      case 14:
        that.isOpenNextMonthBooking = flag;
        break;
      case 15:
        that.isCreatedForGroup = flag;
        break;
      case 16:
        that.isWeeklyRepeatBooking = flag;
        break;
      case 17:
        that.isGSTApplicable = flag;
        break;
    }
  }

  /**
* Change status for view facility mode
*/

  changeStatus(that) {
    try {
      that.isReadOnly = !that.isReadOnly;
      that.editStatus = !that.editStatus;
      this.setLocalFlagWithFacilityRules(that);
      this.setDefaultValues(that);
    } catch (err) {
      console.log(err);
    }
  }

  setLocalFlagWithFacilityRules(that) {
    that.isAttendeeCountRequired = that.facility.isAttendeeCountRequired;
    that.isWaitlistEnabled = that.facility.isWaitlistEnabled;
    that.isMaxBookingsPerSlot = that.facility.isMaxBookingsPerSlot;
    that.isChargable = that.facility.isChargable;
    that.isAllowForceBooking = that.facility.isAllowForceBooking;
    that.isHoldBooking = that.facility.isHoldBooking;
    that.isMaxBookingPerMembership = that.facility.isMaxBookingPerMembership;
    that.isMaxBookingPerPerson = that.facility.isMaxBookingPerPerson;
    that.isPeakTimeEnabled = that.facility.isPeakTimeEnabled;
    that.isBreakTimeEnabled = that.facility.isBreakTimeEnabled;
    that.isOpenBookingOnFriday = that.facility.isOpenBookingOnFriday;
    that.isOpenNextMonthBooking = that.facility.isOpenNextMonthBooking;
    that.isSlotsLocked = that.facility.isSlotsLocked;
    that.isCreatedForGroup = that.facility.isCreatedForGroup;
    that.isWeeklyRepeatBooking = that.facility.isWeeklyRepeatBooking;
    that.isGSTApplicable = that.facility.isGSTApplicable;
  }
  /**
       *
       *
       * Set Default Values if values are undefined or null
       */

  setDefaultValues(that) {
    try {
      if (that.facility.maxNumberOfPeopleWeekend == null || that.facility.maxNumberOfPeopleWeekend === undefined) {
        that.facility.maxNumberOfPeopleWeekend = '';
      }
      if (that.facility.maxNumberOfPeopleWeekday == null || that.facility.maxNumberOfPeopleWeekday === undefined) {
        that.facility.maxNumberOfPeopleWeekday = '';
      }
      if (that.facility.maxNumberOfPeopleWeekday == null || that.facility.maxNumberOfPeopleWeekday === undefined) {
        that.facility.maxNumberOfPeopleWeekday = '';
      }
      if (that.facility.waitlistCount == null || that.facility.waitlistCount === undefined) {
        that.facility.waitlistCount = '';
      }
      if (that.facility.waitlistCount == null || that.facility.waitlistCount === undefined) {
        that.facility.waitlistCount = '';
      }
      if (that.facility.amount.value == null || that.facility.amount.value === undefined) {
        that.facility.amount.value = '';
      }
      if (that.facility.holdBookingDays == null || that.facility.holdBookingDays === undefined) {
        that.facility.holdBookingDays = '';
      }
      if (that.facility.maxWeekdayBooking == null || that.facility.maxWeekdayBooking === undefined) {
        that.facility.maxWeekdayBooking = '';
      }
      if (that.facility.maxWeekendBooking == null || that.facility.maxWeekendBooking === undefined) {
        that.facility.maxWeekendBooking = '';
      }
      if (that.facility.maxBookingHoursWeekday == null || that.facility.maxBookingHoursWeekday === undefined) {
        that.facility.maxBookingHoursWeekday = '';
      }
      if (that.facility.maxBookingHoursWeekend == null || that.facility.maxBookingHoursWeekend === undefined) {
        that.facility.maxBookingHoursWeekend = '';
      }
      if (that.facility.slotDuration == null || that.facility.slotDuration === undefined || that.facility.slotDuration + '' === '0') {
        that.facility.slotDuration = '';
      }
      if (that.facility.isMaxBookingsPerSlot == null || that.facility.isMaxBookingsPerSlot === undefined) {
        that.facility.isMaxBookingsPerSlot = '';
      }
      if (that.facility.GSTValue == null || that.facility.GSTValue === undefined) {
        that.facility.GSTValue = '';
      }
    } catch (err) {
      console.log(err);
    }
  }

  setFlagBeforeViewFacility(that) {
    that.iconSelect = '';
    that.viewIcon.name = '';
    that.viewIcon.iconClass = '';
    that.facility.peekTimings = [];
    that.peekTimingsArray = [];
    that.closeTimeArray = [];
    that.defaultValue = true;
    that.saveFlag = true;
    that.functionHallFlag = false;
    that.viewStatus = true;
    that.isReadOnly = true;
    that.editStatus = false;
  }

  setTimingsForFacility(that) {
    let timeObject = {};
    //that.openTime_hour = that.facility.timings.openTime.replace(/:00:00/g, '');
    let openTime = that.facility.timings.openTime.split(':');
    let closeTime = that.facility.timings.closeTime.split(':');
    that.openTime_hour = ('0' + parseInt(openTime[0])).slice(-2);
    that.openTime_minute = ('0' + parseInt(openTime[1])).slice(-2);

    that.closeTime_hour = ('0' + parseInt(closeTime[0])).slice(-2);
    that.closeTime_minute = ('0' + parseInt(closeTime[1])).slice(-2);

    // that.closeTime = that.facility.timings.closeTime.replace(/:00:00/g, '');
    for (let i = 0; i < that.facility.breakTimings.length; i++) {
      timeObject['start'] = that.facility.breakTimings[i].start.replace(/:00:00/g, '');
      timeObject['end'] = that.facility.breakTimings[i].end.replace(/:00:00/g, '');
      that.closeTimeArray.push(timeObject);
      timeObject = {};
    }
    for (let item of that.facility.peekTimings) {
      timeObject['start'] = item.start.replace(/:00:00/g, '');
      timeObject['end'] = item.end.replace(/:00:00/g, '');
      that.peekTimingsArray.push(timeObject);
      timeObject = {};
    }
  }

  setFlagsForDisableBookings(that) {
    that.functionHallFlag = true;
    that.facility.slotDuration = '';
    that.facilityValidationObj.validate.validSlotDuration = '';
    that.facility.peakUnitsCount = '';
    that.facilityValidationObj.validate.validPeekSlotDuraion = '';
    that.peekTimingsArray = [];
    that.facilityValidationObj.validate.validPeekTime = '';
    that.isPeakTimeEnabled = false;
  }


  /**
  * Remove closed time from closedTime Array
  */

  removeCloseTime(that, time) {
    try {
      let index = that.closeTimeArray.indexOf(time);
      that.closeTimeArray.splice(index, 1);
    } catch (err) {
      console.log(err);
    }
  }

  /**
  * Add closed time in closedTime Array
  */

  addCloseTime(that) {
    try {
      that.closedStartTime = that.closedStartTime_hour && that.closedStartTime_minute ? that.closedStartTime_hour + ':' + that.closedStartTime_minute : '';
      that.closedEndTime = that.closedEndTime_hour && that.closedEndTime_minute ? that.closedEndTime_hour + ':' + that.closedEndTime_minute : '';
      if (that.closedStartTime && that.closedEndTime) {
        that.closedTime['start'] = that.closedStartTime;
        that.closedTime['end'] = that.closedEndTime;
        that.closeTimeArray.push(that.closedTime);
        that.closedTime = {};
        that.closedStartTime_hour = '';
        that.closedStartTime_minute = '';
        that.closedStartTime = '';
        that.closedEndTime = '';
        that.closedEndTime_hour = '';
        that.closedEndTime_minute = '';
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Add peek time in peekTime Array
   */

  addPeekTimings(that) {
    try {
      that.peekStartTime = that.peekStartTime_hour && that.peekStartTime_minute ? that.peekStartTime_hour + ':' + that.peekStartTime_minute : '';
      that.peekEndTime = that.peekEndTime_hour && that.peekEndTime_minute ? that.peekEndTime_hour + ':' + that.peekEndTime_minute : '';
      if (that.peekStartTime && that.peekEndTime) {
        that.peakTime['start'] = that.peekStartTime;
        that.peakTime['end'] = that.peekEndTime;
        that.peekTimingsArray.push(that.peakTime);
        that.peakTime = {};
        that.peekStartTime = '';
        that.peekStartTime_hour = '';
        that.peekStartTime_minute = '';
        that.peekEndTime = '';
        that.peekEndTime_hour = '';
        that.peekEndTime_minute = '';
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
  * Remove peek time from peekTime Array
  */

  removePeakTime(that, time) {
    try {
      let index = that.peekTimingsArray.indexOf(time);
      that.peekTimingsArray.splice(index, 1);
    } catch (err) {
      console.log(err);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/facility/facility-rule/facility-base.ts